<template>
  <!--点击要晒的福利券-->
  <div class='moreTicks_wrapper' v-if="myCoupons.length>0">
   <div class="selectCouponTitle" >
     <span>点击选择要晒的券，可多选</span>
   </div>
   <div class="couponListBox">
     <div class="swiper-container">
       <div class="swiper-wrapper">
       <!-- <div class="couponListBox"> -->
       <div  v-for="(item,index) in myCoupons" class="couponPicItem swiper-slide" @click='selectedCoupon(index)'>
         <img :src="item.listPic" class="couponPic" />
         <div class="selected_wrapper">
           <div class="icon-right icon_right_color"></div>
         </div>
       </div>
       <!-- </div> -->
     </div>
      </div>
   </div>
 </div>
</template>
<script type = "text/ecamscript-6">
  import Vue from 'vue'
  import SwiperVue from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  export default {
    name:'baskCoupons',
    props:['myCoupons'],
    data() {
      return{
      }
    },
    created () {
      //console.log(this.)
      this.$nextTick(() => {
       var mySwiper = new SwiperVue('.swiper-container', {
         "autoplay": "true",
         "slidesPerView" : '3',
         'direction': 'horizontal',
          'loop': "true",
       })
   })
    },
    methods:{

        selectedCoupon(index){
          this.$emit('selectedCouponParent',index)
        }
    }
  }
</script>
<style lang="stylus">
  .moreTicks_wrapper
    width: 100%
    text-align: left
    padding:40px 30px
    border-top:1px solid #e5e5e5
    /*px*/
    background: #fff
    box-sizing: border-box
    .selectCouponTitle
      font-size: 30px
      color: #333
    .couponListBox
      padding-top: 30px
      width:660px
      .couponPicItem
        width: 200px
        height: 200px
        position: relative
        display: inline-block
        .couponPic
          width:200px
          height:200px
          display:block
        .selected_wrapper
          width: 196px
          height: 196px
          background: rgba(0,0,0,0.6)
          position: absolute
          left: 0px
          top: 0px
          .icon_right_color
            width: 40px
            height: 40px
            color:#625a4c
            font-size: 24px
            text-align: center
            background: #fff
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%,-50%)
            border-radius: 50%
            line-height: 40px
</style>



// WEBPACK FOOTER //
// src/components/quan/baskCoupons.vue